import React from 'react'
import styled from 'styled-components'
import { RowBetween } from '../../../components/Row'
import search from '../../../assets/images/search.svg'

const SearchWrapper = styled(RowBetween)`
  width: 192px;
  height: 32px;
  border-radius: 32px;
  overflow: hidden;
  border: 1px solid ${({ theme }) => theme.bsBorder4};
`
const SearchInput = styled.input`
  padding: 0 10px;
  width: 100%;
  height: 40px;
  line-height: 20px;
  flex-grow: 1;
  color: ${({ theme }) => theme.bsText14};
  contenteditable: true;
  font-size: 16px;
  outline: none;
  background: initial;
  border: none;
  /* -webkit-appearance: none; */
  /* -webkit-text-fill-color: ${({ theme }) => theme.bsText14}; */
  
  ::placeholder {
    color: ${({ theme }) => theme.bsText14};
  }
`
const SearchImg = styled.div`
  width: 40px;
  line-height: 40px;
  border-radius: 10px;
  text-align: center;
  flex-shrink: 0;
  cursor: pointer;
  background: initial;
  img {
    width: 15px;
    height: 15px;
    vertical-align: middle;
  }
`

export default function Search({value, inputChange, searchHandle}: {value: string, inputChange: any, searchHandle: any}) {
  return (<>
    <SearchWrapper>
      <SearchInput value={value}
        onChange={event => {
          inputChange(event)
        }}></SearchInput>
      <SearchImg onClick={() => {searchHandle(value)}}>
        <img src={search} alt=""/>
      </SearchImg>
    </SearchWrapper>
  </>)
}
